<template>
	<div class="preview_preview_wrap_out"
		:style="{'display': popShow ? 'block' : 'none', 'width': isBig ? '521px' : '394px', 'height': isBig ? '512px' : '420px', left: popX + 'px', 'top': popY + 'px'}"
		@mouseenter="mouseenter" @mouseleave="mouseleave" @click="naviToDetails">
		<div class="preview_preview_pos">
			<img :src="curReCommand.CoverURL" referrerPolicy="no-referrer" class="preview_preview_img">
			<p class="preview_preview_title">{{curReCommand.Title}}</p>
			<p class="preview_preview_subtitle">{{'播放量：' + curReCommand.Clicks}}</p>
			<p class="preview_preview_desc">
				{{curReCommand.Intro}}
			</p>
			<!-- <img src="http://m.ykimg.com/058300006514E813142722186CA1CF56?x-oss-process=image/resize,w_640/crop,x_0,y_0,w_640,h_360"
				class="preview_preview_img">
			<p class="preview_preview_title">南风知我意</p>
			<p class="preview_preview_subtitle">爱情·都市</p>
			<p class="preview_preview_desc">
				傅云深与朱旧在欠发达地区进行人道医疗救援，两人从误解到经历生死后的两心相许，还来不及坦诚心意，一场事故让傅云深陷入人生低谷，他斩断与朱旧的联系。一年后，朱旧以家庭医生的身份与傅云深重逢，面对他的百般刁难，朱旧用坚韧乐观的心态与不离不弃的爱慢慢治愈云深，陪他走出黑暗深渊。
			</p> -->
			<p class="preview_preview_btn">立即播放</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'popMenu',
		props: {
			popX: {
				type: Number,
				default: 0,
			},
			popY: {
				type: Number,
				default: 0,
			},
			isPop: {
				type: Boolean,
				default: false,
			},
			isBig: {
				type: Boolean,
				default: false,
			},
			curReCommand: {
				type: Object,
				default: {}
			}
		},
		data() {
			return {
				popShow: false,
			}
		},
		watch: {
			isPop(val) {
				this.popShow = val
			}
		},
		methods: {
			naviToDetails() {
				this.$emit('naviToDetails', this.curReCommand.VId)
			},
			mouseenter() {
				this.popShow = true
				this.$emit('changeIsPop', true)
			},
			mouseleave() {
				this.popShow = false
				this.$emit('changeIsPop', false)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.preview_preview_wrap_out {
		position: absolute;
		z-index: 9;
		background: #25252b;
		border-radius: 10px;
		box-shadow: 0 10px 70px 0 #000;
		overflow: hidden;
		-webkit-animation: preview_previewin .3s cubic-bezier(.86, 0, .07, 1);
		animation: preview_previewin .3s cubic-bezier(.86, 0, .07, 1);
		-webkit-animation-fill-mode: forwards;
		animation-fill-mode: forwards;
	}

	.preview_preview_pos {
		display: block;
		width: 100%;
		height: 100%;
		cursor: pointer;
		position: relative
	}

	.preview_preview_pos:before {
		content: "";
		position: absolute;
		left: 0;
		bottom: 199px;
		width: 100%;
		height: 40px;
		background-image: -webkit-gradient(linear, left top, left bottom, from(transparent), to(rgba(0, 0, 0, .2)));
		background-image: -webkit-linear-gradient(top, transparent, rgba(0, 0, 0, .2));
		background-image: linear-gradient(180deg, transparent, rgba(0, 0, 0, .2))
	}

	.preview_preview_pos:after {
		content: "";
		position: absolute;
		left: 50%;
		margin-left: -9px;
		top: 50%;
		margin-top: -120px;
		width: 18px;
		height: 21px;
		background-image: url("data:image/png;base64,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");
		background-repeat: no-repeat;
		background-position: 50%;
		background-size: 18px 21px
	}

	.preview_preview_img {
		width: 100%;
		height: calc(100% - 219px);
		margin: 0 auto;
	}

	.preview_preview_title {
		margin: 21px 45px 0 21px;
		font-size: 18px;
		font-weight: 500;
		color: #eaeaea;
		text-align: left;
		height: 25px;
		line-height: 25px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.preview_preview_subtitle {
		margin: 6px 21px 0;
		font-size: 14px;
		height: 20px;
		line-height: 20px;
		color: #999;
		text-align: left;
		font-weight: 400;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.preview_preview_desc {
		margin: 15px 21px 0;
		font-size: 14px;
		height: 60px;
		line-height: 20px;
		color: #999;
		text-align: left;
		font-weight: 400;
		display: -webkit-box;
		overflow: hidden;
		white-space: normal;
		text-overflow: ellipsis;
		word-wrap: break-word;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical
	}

	.preview_preview_btn {
		position: absolute;
		left: 21px;
		bottom: 21px;
		width: 72px;
		height: 30px;
		border-radius: 15px;
		background: #ff008c;
		font-size: 12px;
		line-height: 30px;
		text-align: center;
		color: #FFFFFF;
		font-weight: 500;
		margin: 0px;
	}
</style>